import { defineComponent as n, computed as r, openBlock as d, createElementBlock as i, normalizeClass as p, renderSlot as f } from "vue";
const u = ["data-type"], y = /* @__PURE__ */ n({
  __name: "BaseTableRow",
  props: {
    type: { default: "body" },
    align: { default: "left" },
    selected: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(l, { emit: a }) {
    const t = l, s = a, o = r(() => {
      const e = ["table-row", `table-row-${t.type}`];
      return t.selected && e.push("table-row-selected"), t.selectable && e.push("table-row-selectable"), e.join(" ");
    }), c = (e) => {
      t.selectable && s("click", e);
    };
    return (e, m) => (d(), i("tr", {
      class: p(o.value),
      "data-type": l.type,
      onClick: c
    }, [
      f(e.$slots, "default")
    ], 10, u));
  }
});
export {
  y as default
};
